import { render, staticRenderFns } from "./AdminEditUserTable.vue?vue&type=template&id=664aabd7&scoped=true&"
import script from "./AdminEditUserTable.vue?vue&type=script&lang=js&"
export * from "./AdminEditUserTable.vue?vue&type=script&lang=js&"
import style0 from "./AdminEditUserTable.vue?vue&type=style&index=0&id=664aabd7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664aabd7",
  null
  
)

export default component.exports